import { Accordion } from 'foundation-sites/dist/js/foundation.esm.js'

const SELECTORS = Selectors({
  accordion: '[data-accordion]'
})

const $accordions = document.querySelectorAll(SELECTORS.accordion)

const fn = {
  init: () => {
    $accordions.forEach($el => {
      $el.querySelector('.accordion-item:first-child').classList.add('is-active')
      new Accordion($($el), {
        allowAllClosed: true
      })
    })
  }
}

export default {
  can: () => $accordions.length,
  run: fn.init
}
